import React from 'react';

const CourseRow = ({ course, editCourse, deleteCourse, courseNumber }) => {
    return (
        <tr className="course-row">
            <td>{courseNumber}</td>
            <td>{course.text}</td>
            <td>
                <a href={course.url} target="_blank" rel="noopener noreferrer" className="course-link">
                    {course.url}
                </a>
            </td>
            <td className="actions-cell">
                <button onClick={editCourse} className="edit-btn">
                    Редактировать
                </button>
                <button onClick={deleteCourse} className="delete-btn">
                    Удалить
                </button>
            </td>

            <style>{`
                .course-row:hover {
                    background-color: #f8f9fa;
                }
                
                .course-row td {
                    padding: 12px 15px;
                    border-bottom: 1px solid #dee2e6;
                }
                
                .course-link {
                    color: #007bff;
                    text-decoration: none;
                    word-break: break-all;
                }
                
                .course-link:hover {
                    text-decoration: underline;
                }
                
                .actions-cell {
                    display: flex;
                    gap: 8px;
                }
                
                .edit-btn {
                    padding: 6px 12px;
                    background-color: #17a2b8;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                
                .edit-btn:hover {
                    background-color: #138496;
                }
                
                .delete-btn {
                    padding: 6px 12px;
                    background-color: #dc3545;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: all 0.2s;
                } 
                
                .delete-btn:hover {
                    background-color: #c82333;
                }
            `}</style>
        </tr>
    );
};

export default CourseRow;